<template>
    <div
            class="VFeatureBlock-wrapper"
            :class="`VFeatureBlock-${feature.name}`"
            @mousedown="handleFeatureMouseDown"
            @mouseover="handleFeatureMouseOver"
    >
        <div
                class="VFeatureBlock"
                :style="{'width':featureWidth}"
                v-show="!isShowLoadingForCurrentFeature"
        >
            <div class="VFeatureBlock-title-bar">
                <div class="VFeatureBlock-title-bar__name-and-color">
                    <div
                            class="VFeatureBlock-title-bar__name"
                            :style="filters ? 'color:#6089E7':''"
                    >
                        {{ feature.name }}
                        <slot name="afterFeatureName"></slot>
                    </div>
                    <div
                            class="VFeatureBlock-title-bar__colors"
                            v-if="feature.colors.length && isTableView"
                    >
                        <div
                                class="VFeatureBlock-title-bar__color VFeatureBlock-title-bar__color_noselected"
                                @click="selectColor('')"
                                :class="{'VFeatureBlock-title-bar__color_active': feature.selectedColors.includes('')}"
                        >
                        </div>
                        <div
                                class="VFeatureBlock-title-bar__color-wrapper"
                                v-for="(color) in feature.colors"
                                :key="color"
                                :class="{'VFeatureBlock-title-bar__color_active': feature.selectedColors.includes(color)}"
                        >

                            <div
                                    class="VFeatureBlock-title-bar__color"
                                    @click="selectColor(color)"
                                    :style="{background:color}"
                            >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                    class="VFeatureBlock-title-bar__settings noselect"
            >
                <slot name="beforeHeaderSettings"></slot>
<!--                <span-->
<!--                        class="column-button"-->
<!--                >-->
<!--                <VButton-->
<!--                        v-if="additionalColumns && additionalColumns[0].type === 'input' &&  currentArppuColumn.columnIndex != null"-->
<!--                        @click=deleteChangedAdditionalColumnsValue-->
<!--                        theme="positive"-->
<!--                        type="button"-->
<!--                >Set default-->
<!--                </VButton>-->
<!--                <VButton-->
<!--                        v-else-if="isPossibleSetDefaultForAll"-->
<!--                        @click=setArppuAllDefaultValues-->
<!--                        theme="positive"-->
<!--                        type="button"-->
<!--                >Set defaults-->
<!--                </VButton>-->
<!--                <VButton-->
<!--                        v-if="additionalColumns && additionalColumns[0].type === 'input'"-->
<!--                        :disabled="!isAdditionalColumnsChanged"-->

<!--                        @click=applyAdditionalChanges-->
<!--                        theme="positive"-->
<!--                        type="button"-->
<!--                >Set {{ additionalColumns[0].name }}-->
<!--                </VButton>-->
<!--                    </span>-->
                <template v-if="['Summary'].includes(feature.name)">
                    <div
                            class="VFeatureBlock-title-bar__mark"
                            v-if="isShowHighlightedSettings"
                            @click="showHighlightedDropdownVisibility"
                    >
                        <font-awesome-icon
                                icon="fa-solid fa-pen"
                        />
                    </div>
                    <span
                            v-if="isHighlightedDropdownOpened"
                            class="VFeatureBlock-title-bar__mark-dropdown"
                            v-click-outside="hideHighlightedDropdownVisibility"
                    >
                        <div class="VFeatureBlock-title-bar__mark-dropdown-settings">
                            <span>
                                <span
                                        :class="{disabled:!isAllowSaveMark}"
                                        @click="markSpecialRow"
                                >
                                    <font-awesome-icon
                                            icon="fa-solid fa-check"
                                    />
                                </span>
                                <span
                                        :class="{disabled:!isAllowSaveMark}"
                                        @click="deleteMarkSpecialRow"
                                >
                                 <font-awesome-icon
                                         icon="fa-solid fa-xmark"
                                 />
                                </span>
                            </span>
                            <span @click="unmarkSpecialRow">
                            <font-awesome-icon
                                    v-show="currentSummaryNotes.body.length"
                                    icon="fa-solid fa-trash"
                            /></span>
                        </div>
                           <VTextArea
                                   v-model.trim="markedTextTemp"
                                   :rows="5"
                           />
                        
                        </span>
                    <div
                            v-if="isTableView && !isLoadedFromPopup "
                            class="VFeatureBlock-title-bar__popup"
                            @click="showTablePopup"
                    ></div>
                </template>
                <div
                        v-else-if="!isTableView && !isLoadedFromPopup"
                        class="VFeatureBlock-title-bar__popup"
                        @click="showChartPopup"
                ></div>
                <div
                        class="VSearch-wrapper"
                        v-if="isTableView"
                >
                    <span
                            class="VSearch"
                            @keydown.esc="hideInput"
                            @focusout="hideInput"
                            @mouseover="showTooltip($event,'text','Search by name')"
                    >
                         <span
                                 class="VSearch-icon"
                                 @click="showInput"
                                 v-if="!isSearchActive"
                                 :class="search.length ? 'VInput-search_active':''"
                         ><img
                                 src="/icons/components/VFeatureBlock/icon_search.svg"
                                 alt="Settings"
                         ></span>
                         <VInput
                                 v-if="isSearchActive"
                                 v-model.trim="search"
                                 :placeholder="'Type something...'"
                                 @enter="pressedEnterInSearch"
                                 ref="vinput"
                         >
                         </VInput>
                    </span>
                </div>
                <template v-if="isNotSummaryTable && isTableView">
                        <span
                                class="VFeatureBlock-color-picker"
                        >
                          <div
                                  @click="showFeatureColorPickerVisibility"
                                  @mouseover="showTooltip($event,'text','Highlight lines with color')"
                                  :class="{'disabled':!areRowsSelected}"
                                  class="VFeatureBlock-color-picker-icon"
                          >
                          </div>
                          <span
                                  v-if="isColorPickerActive"
                                  class="VFeatureBlock-color-picker-dropdown"
                                  v-click-outside="hideFeatureColorPickerVisibility"
                          >
                              <span
                                      class="VFeatureBlock-color-picker-dropdown-icon"
                                      @click="hideFeatureColorPickerVisibility"
                              >
                            </span>
                              <span
                                      class="VFeatureBlock-color-picker-dropdown__block VFeatureBlock-color-picker-dropdown__block_close"
                                      @click="changeSelectColor('')"
                              ></span>
                            <span
                                    class="VFeatureBlock-color-picker-dropdown__block"
                                    v-for="(color) in selectColors"
                                    :key="color"
                                    :style="{background: color}"
                                    @click="changeSelectColor(color)"
                            ></span>
                        </span>
                    </span>

                </template>
                <span
                        class="VFeatureBlock-download-icon"
                        @click="download"
                        v-if="isTableView"
                >
                </span>
                <span class="VFeatureBlock-settings">
                    <div
                            class="VFeatureBlock-settings-icon"
                            @click="showFeatureSettingsVisibility"
                            @mouseover="showTooltip($event,'text','Select events and formulas')"
                    >
                    </div>
                    <div
                            v-if="isSettingsActive"
                            class="VFeatureBlock-settings-dropdown"
                            v-click-outside="hideFeatureSettingsVisibility"
                    >
                          <span
                                  class="VFeatureBlock-settings-dropdown-icon"
                                  @click="hideFeatureSettingsVisibility"
                          >
                            </span>
                        <div class="VFeatureBlock-settings-dropdown-block">
                        <VLineBlock
                                :items="getActiveEvents()"
                                :deleted-items="getDeletedEvents()"
                                :show-name="'Events'"
                                :sync="false"
                                :is-can-add-item="false"
                                @remove="removeEvent"
                                @add="addEvent"
                        ></VLineBlock>
                        <VLineBlock
                                :items="getActiveFormulas()"
                                :deleted-items="getDeletedFormulas()"
                                :show-name="'Formulas'"
                                :sync="false"
                                :is-can-add-item="false"
                                @remove="removeFormula"
                                @add="addFormula"
                        ></VLineBlock>
                            <span class="VFeatureBlock-settings-dropdown-label">Display Type:</span>
                                <VRadioSwitcher
                                        :options="featureViewsSelected"
                                        :type="'Array'"
                                        :sync="false"
                                        @updateOptions="changeFeatureChart"
                                >
                                </VRadioSwitcher>
                            </div>
                    </div>
                </span>
                <span
                        class="VFeatureBlock-close-icon"
                        v-if="isClosable"
                        @click="closeFeature"
                >
                    </span>
            </div>
            <template v-if="isTableView">
                <div class="VFeatureBlock-headers-background-border"></div>
                <VFeatureVirtualTable
                        v-if="isShowDatatable"
                        :items="datatableItems"
                        :items-changes="feature.itemsChanges"
                        :feature="feature"
                        :sum-rows="feature.sumRows"
                        :selected-ids="feature.selectedIds"
                        :show-headers-names="showHeadersNames"
                        :feature-settings="featureSettings"
                        :feature-index="featureIndex"
                        :filter-value="feature.filterValue"
                        :short-feature-name="shortFeatureName"
                        :is-sum-plus-visible="feature.selectedIds.length > 1"
                        :items-count="itemsCount"
                        :is-loaded-from-popup="isLoadedFromPopup"
                        :additional-columns="additionalColumns"
                        :changed-additional-columns="changedAdditionalColumns"
                        :summaryNotes="summaryNotes"
                        :current-board="currentBoard"
                        ref="virtualtable"
                        @selectRow="selectRow"
                        @selectRowWithShift="selectRowWithShift"
                        @selectAllRowExceptClicked="selectAllRowExceptClicked"
                        @sumRows="sumRows"
                        @deleteSumRow="deleteSumRow"
                        @filterClickedRow="filterClickedRow"
                        @filterByValue="filterByValue"
                        @setCurrentArppuColumn="setCurrentArppuColumn"
                        @saveDashboardDebouncedLong="saveDashboardDebouncedLong"
                        @updateChangedAdditionalColumns="updateChangedAdditionalColumns"
                        @showTooltip="showTooltip"
                        @addGeoData="addGeoData"
                ></VFeatureVirtualTable>
            </template>
            <template v-else>
                <div class="VFeatureBlock-chart">
                    <component
                            :is="chartComponent"
                            :chart-data="chartData"
                            :options="chartOptions"
                    >
                    </component>
                </div>

            </template>
        </div>
        <div
                v-if="isShowLoadingForCurrentFeature"
                class=" VFeatureBlock-loading"
                :style="{width: `${loadingWidth}px`,height:featureSettings.featureLoadingHeight}"
        >
            <div class="VFeatureBlock-loading-title-bar">
                <div class="VFeatureBlock-loading-row VFeatureBlock-loading-row_small"></div>
                <div class="VFeatureBlock-loading-row VFeatureBlock-loading-row_big"></div>
            </div>
            <div class="VFeatureBlock-loading-body">
                <div class="VFeatureBlock-loading-row VFeatureBlock-loading-row_big"></div>
                <div class="VFeatureBlock-loading-row VFeatureBlock-loading-row_big"></div>
                <div class="VFeatureBlock-loading-row VFeatureBlock-loading-row_big"></div>
                <div class="VFeatureBlock-loading-row VFeatureBlock-loading-row_big"></div>
                <div class="VFeatureBlock-loading-row VFeatureBlock-loading-row_big"></div>
                <div class="VFeatureBlock-loading-row VFeatureBlock-loading-row_big"></div>
                <div class="VFeatureBlock-loading-row VFeatureBlock-loading-row_big"></div>
                <div class="VFeatureBlock-loading-row VFeatureBlock-loading-row_big"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        exportRowsToFile,
        sortPropertyIndex,
        sortByPropertyNameForStrings,
        sortByPropertyNameForNumbers,
        sortByPropertyNameForDates,
    } from '@/helpers/dataHelper';
    import {
        getSummaryEvents,
    } from '@/api/apiServices';
    import selectColors from './VFeatureBlock/selectColors.json';
    import {fixBlockIntersection} from '../helpers/coordinatesHelper';
    import {areArraysEqual} from '@/helpers/dataHelper';
    import {getTextWidth, getNodeIndex} from '@/helpers/domHelper';
    import VFeatureVirtualTable from './VFeatureBlock/VFeatureVirtualTable';
    import {createCssRules, deleteCssRules} from '../helpers/domHelper';
    import {eventBus} from '../main';
    import {removeSelection} from '../helpers/domHelper';
    import featureViews from './VFeatureBlock/views.json';
    import Bar from './VFeatureBlock/VFeatureBlockCharts/VFeatureBlockChart-bar';
    import {generateChartSettings} from './VFeatureBlock/generateChartSettings';
    import {
        changeFeatureWidthOnColumnWidth,
    } from '../pages/Dashboard/FeaturesBlock/calcs';
    import {getNameAliases, getTableColumnWidth, getTableColumnWidthActiveColumns} from '../helpers/dataHelper';
    import {triggerAdditionalDataCb} from '../helpers/additionalColumnsHelper';
    import apiEvents from '../api/apiEvents';
    import {getPrecisionFormat} from '../helpers/dateTimeHelper';
    import {getFeaturesWithRevenueEvents} from "../api/apiServices";

    export default {

        name: 'VFeatureBlock',
        components: {
            VFeatureVirtualTable,
            Bar,
        },
        props: {
            feature: {
                type: Object,
                required: false,
            },
            filters: {
                type: Object,
                required: false,
            },
            events: {
                type: Array,
                required: true,
            },
            deletedEventsAndFormulasIndexes: {
                type: Array,
                required: true,
            },
            allEventsAndAllFormulas: {
                type: Array,
                required: true,
            },
            formulas: {
                type: Array,
                required: true,
            },
            isClosable: {
                type: Boolean,
                default: false,
            },
            featureIndex: {
                type: Number,
                required: true,
            },
            isNotSummaryTable: {
                type: Boolean,
                default: true,
            },
            isDashboardLoaded: {
                type: Boolean,
                default: false,
            },
            isFeatureUpdating: {
                type: Boolean,
                default: false,
            },
            featureSettings: {
                type: Object,
                required: true,
            },
            showHeadersNames: {
                type: Array,
                required: true,
            },
            headersNames: {
                type: Array,
                required: true,
            },
            allEvents: {
                type: Array,
                required: true,
            },
            allFormulas: {
                type: Array,
                required: true,
            },
            numberTypeFeaturesNames: {
                type: Array,
                default: () => [],
            },
            dateTypeFeaturesNames: {
                type: Array,
                default: () => [],
            },
            headersWidth: {
                type: Array,
                default: () => [],
            },
            currentBoardClass: {
                type: String,
                required: true,
            },
            boardStyles: {
                type: Object,
                required: true,
            },
            bundleIdsOptions: {
                type: Array,
                required: true,
            },
            eventSwitcherOptions: {
                type: Array,
                required: true,
            },
            currentBoard: {
                type: Object,
                required: true,
            },
            isLoadedFromPopup: {
                type: Boolean,
                default: false,
            },
            itemsCount: {
                type: Number,
                default: 20,
            },
        },
        data() {
            return {
                currentSummaryNotes: {
                    body: '',
                    date: '',
                },
                chartComponent: '',
                featureViews: [],
                search: '',
                isSettingsActive: false,
                isColorPickerActive: false,
                selectColors,
                datatableItems: [],
                isShowLoadingForCurrentFeature: false,
                isSearchActive: false,
                isShowDatatable: true,
                chartData: {
                    datasets: '',
                    labels: '',
                },
                chartOptions: {},
                isAdditionalColumnsChanged: false,
                changedAdditionalColumns: {},
                markedTextTemp: '',
                isHighlightedDropdownOpened: null,
                currentArppuColumn: {
                    columnIndex: null,
                    name: '',
                },
            };
        },
        watch: {
            additionalColumns: {
                deep: true,
                immediate: true,
                handler() {
                    this.changedAdditionalColumns = _.cloneDeep(this.additionalColumns);
                    this.isAdditionalColumnsChanged = false;
                },
            },
            featureDeletedIndexes: {
                handler() {
                    if (this.feature.styles) {
                        this.updateColumnVisibilityStyles();
                        this.calcWidthForColumns();
                    }
                },
            },
            events: {
                immediate: true,
                handler(newEvents, oldEvents) {
                    this.feature.events = Object.freeze(_.cloneDeep(newEvents));
                    if (!getFeaturesWithRevenueEvents().includes(this.feature.name.toLowerCase()) && this.feature.styles && (!oldEvents || (oldEvents && newEvents.length >
                        oldEvents.length))) {
                        this.hideSummaryEvents(newEvents);
                    }
                    if (oldEvents) {
                        this.getChartData('events');
                    }
                },
            },
            formulas: {
                immediate: true,
                handler(newFormulas) {
                    this.feature.formulas = Object.freeze(_.cloneDeep(newFormulas));
                },
            },
            isFeatureUpdating: {
                immediate: true,
                handler(isFeatureUpdating) {
                    if (isFeatureUpdating) {
                        this.isShowLoadingForCurrentFeature = true;
                        this.isShowDatatable = false;
                        this.clearData();
                    } else if (!getFeaturesWithRevenueEvents().includes(this.feature.name.toLowerCase()) && this.feature.styles) {
                        this.hideSummaryEvents(this.events);
                    }
                },
            },
            search: {
                handler() {
                    this.filterByNameDebounced();
                },
            },
            'feature.name': {
                deep: true,
                immediate: true,
                handler() {
                    if (!this.isFeatureUpdating) {
                        if (this.feature.assignedItems) {
                            this.assignDatatableItems(this.feature.assignedItems, true);
                        } else {
                            this.filterByName();
                        }
                    }
                },
            },
            'feature.selectedIds': {
                deep: false,
                immediate: false,
                handler(newIds, oldIds) {
                    if (JSON.stringify(newIds) !== JSON.stringify(oldIds)) {
                        this.highlightSelectedRows(newIds);
                    }
                },
            },
            'feature.sumRows': {
                deep: true,
                immediate: true,
                handler(newSumRows, oldSumRows) {
                    if (!oldSumRows || oldSumRows && newSumRows.length !== oldSumRows.length) {
                        this.calcWidthForColumns();
                    }
                },
            },
            'featureSettings.featureView': {
                deep: false,
                immediate: false,
                handler(futureView) {
                    if (!this.isFeatureUpdating && !this.isTableView) {
                        this.getChartData('featureSettings.featureView');
                        this.importChartComponent(futureView);
                    }
                },
            },
        },
        computed: {
            isPossibleSetDefaultForAll() {
                let result = false;
                if (!this.isAdditionalColumnsChanged && this.feature.name.toLowerCase().trim() === 'product_id' && this.changedAdditionalColumns && this.changedAdditionalColumns[0]) {
                    const arppuData = this.changedAdditionalColumns[0].data;
                    Object.entries(arppuData).forEach(([key, value]) => {
                        const valueDefault = this.currentBoard.tempData.arrpusDefault[key];
                        if (valueDefault != null && valueDefault !== value) {
                            result = true;
                        }
                    });
                }
                return result;
            },
            summaryNotes() {
                if (this.isNotSummaryTable || !this.currentBoard.summaryNotes.length || this.currentBoard.precision !== 'day') {
                    return {};
                } else {
                    const format = getPrecisionFormat('day');
                    return this.currentBoard.summaryNotes.reduce((noteObj, currentValue) => {
                        noteObj[this.$moment(currentValue.date).format(format)] = true;
                        return noteObj;
                    }, {});
                }
            },
            isShowHighlightedSettings() {
                return this.feature.selectedIds.length === 1 && this.currentBoard.precision === 'day';
            },
            isAllowSaveMark() {
                return this.markedTextTemp !== this.currentSummaryNotes.body;
            },
            nameAliases() {
                return getNameAliases(this.shortFeatureName.toLowerCase());
            },
            featureDeletedIndexes() {
                const deletedEventsNames = this.featureSettings.deletedEventsNames || [];
                const deletedFormulasNames = this.featureSettings.deletedFormulasNames || [];
                const deletedColumnsNames = deletedEventsNames.concat(deletedFormulasNames);
                const deletedColumnsNamesObject = deletedColumnsNames.reduce((obj, name) => {
                    obj[name] = true;
                    return obj;
                }, {});
                const columns = this.headersNames;
                const deletedIndexes = columns.reduce((indexes, name, index) => {
                    if (deletedColumnsNamesObject[name]) {
                        indexes.push(index);
                    }
                    return indexes;
                }, []);
                return deletedIndexes;
            },
            additionalColumns() {
                return this.currentBoard.additionalColumnsByFeatureName[this.shortFeatureName.toLowerCase()];
            },
            featureWidth() {
                return this.featureSettings.width ? `${this.featureSettings.width}px` : 'auto';
            },
            loadingWidth() {
                return (Math.max(this.featureSettings.width, 350) + 4);
            },
            isTableView() {
                return !this.featureSettings.featureView || this.featureSettings.featureView.toLowerCase() === 'table';
            },
            featureViewsSelected() {
                if (this.featureSettings.featureView) {
                    return Object.freeze(this.featureViews.map((view) => {
                        return Object.assign({
                            isSelected: this.featureSettings.featureView.toLowerCase() === view.name.toLowerCase(),
                        }, view);
                    }));
                }
                return Object.freeze(this.featureViews.map((view, viewIndex) => {
                    return Object.assign({
                        isSelected: viewIndex === 0,
                    }, view);
                }));
            },
            shortFeatureName() {
                return this.feature.name.split(' ')[0];
            },
            shortcutByFeatureClass() {
                return `.${this.currentBoardClass} .VFeatureBlock-${this.shortFeatureName}`;
            },
            areRowsSelected() {
                return !!this.feature.selectedIds.length;
            },
            filterByNameDebounced() {
                const DELAY = 200;
                const self = this;
                return _.debounce(function () {
                    self.filterByName('debounced');
                }, DELAY);
            },
        },
        beforeCreate() {
            this.itemsFiltered = {
                byName: [],
                byValue: [],
                byColor: [],
            };
            this.handleMoveOnly = false;
        },
        created() {
            this.featureViews = this.getAvailableViews();
            this.clearTableSelection();
            eventBus.$on('App-event-mouseup', this.handleGlobalMouseUp);
            this.initAdditionalColumns();
        },
        beforeDestroy() {
            eventBus.$off('App-event-mouseup', this.handleGlobalMouseUp);
        },
        methods: {
            addGeoData(row){
              this.$emit('addGeoData',row);
            },
            addOrUpdateSummaryNote(newSummaryNote) {
                const existingIndex = this.currentBoard.summaryNotes.findIndex(
                    (note) => note.date === newSummaryNote.date,
                );

                if (existingIndex !== -1) {
                    // Обновить существующую заметку
                    this.currentBoard.summaryNotes.splice(existingIndex, 1, newSummaryNote);
                } else {
                    // Добавить новую заметку
                    this.currentBoard.summaryNotes.push(newSummaryNote);
                }
            },
            markSpecialRow() {
                if (this.isAllowSaveMark) {
                    const rowDate = this.currentSummaryNotes.date;
                    const momentDate = this.$moment.utc(rowDate, 'MMM DD,YYYY');
                    const isUTC = this.currentBoard.datePeriod.utc;
                    const date = this.$moment(momentDate, 'YYYY-MM-DD[T]HH:mm:ss[Z]').format('YYYY-MM-DD[T]HH:mm:ss[Z]');
                    const notesData = {
                        date,
                        body: this.markedTextTemp,
                        offset: isUTC ? 0 : this.$moment().utcOffset() * 60,
                    };

                    apiEvents.setSummaryNotes(notesData).then(() => {

                    });
                    this.addOrUpdateSummaryNote({
                        date,
                        body: this.markedTextTemp,
                    });
                    this.hideHighlightedDropdownVisibility();
                }
            },
            unmarkSpecialRow() {
                const rowDate = this.currentSummaryNotes.date;
                const momentDate = this.$moment.utc(rowDate, 'MMM DD,YYYY');
                const isUTC = this.currentBoard.datePeriod.utc;
                const notesData = {
                    date: this.$moment(momentDate, 'YYYY-MM-DD[T]HH:mm:ss[Z]'),
                    body: '',
                    offset: isUTC ? 0 : this.$moment().utcOffset() * 60,
                };
                apiEvents.setSummaryNotes(notesData).then(() => {
                });
                this.currentBoard.summaryNotes.splice(this.currentSummaryNotes.savedIndex, 1);

                this.hideHighlightedDropdownVisibility();
            },
            deleteMarkSpecialRow() {
                this.markedTextTemp = this.currentSummaryNotes.body;
            },
            showHighlightedDropdownVisibility() {
                const row = this.feature.rows[this.feature.selectedIds[0]];
                const date = row.value;
                const savedIndex = Object.keys(this.summaryNotes).findIndex((noteDate) => noteDate === date);
                const body = savedIndex >= 0 ? this.currentBoard.summaryNotes[savedIndex].body : '';
                this.markedTextTemp = body;
                this.currentSummaryNotes = {
                    date,
                    savedIndex,
                    body,
                };

                this.isHighlightedDropdownOpened = true;
            },
            hideHighlightedDropdownVisibility() {
                this.isHighlightedDropdownOpened = false;
                this.$emit('clearRowsFromFeature');
                this.currentSummaryNotes = {
                    body: '',
                    date: '',
                };
                this.markedTextTemp = '';
            },
            applyAdditionalChanges() {
                this.isAdditionalColumnsChanged = false;
                this.changedAdditionalColumns.forEach((column) => {
                    for (let key in column.data) {
                        if (column.data[key] === null || column.data[key] === '') {
                            delete column.data[key];
                        }
                    }
                });
                this.currentBoard.additionalColumnsByFeatureName[this.shortFeatureName.toLowerCase()] =
                    _.cloneDeep(this.changedAdditionalColumns).map((column) => {
                        const newColumn = _.cloneDeep(column);
                        delete newColumn.isChanged;
                        return newColumn;
                    });
                this.additionalColumns.forEach((column) => {
                    this.$nextTick(() => {
                        triggerAdditionalDataCb(this.currentBoard, this.shortFeatureName, column.updateFeaturesNames,
                            {});
                    });
                });

                this.$emit('saveDashboard');
            },
            saveDashboardDebouncedLong() {
                this.$emit('saveDashboardDebouncedLong');
            },
            updateChangedAdditionalColumns(value, columnIndex, name) {
                const column = this.changedAdditionalColumns[columnIndex];
                const columnOriginal = this.additionalColumns[columnIndex];
                this.$set(column.data, name, value);
                Object.keys(column.data).forEach((key) => {
                    if (!(key in columnOriginal.data) && (key in column.data) && column.data[key] === '') {
                        delete column.data[key];
                    }
                });
                this.isAdditionalColumnsChanged = JSON.stringify(this.changedAdditionalColumns[columnIndex]) !== JSON.stringify(this.additionalColumns[columnIndex]);

            },
            setArppuAllDefaultValues() {
                const arppuData = this.changedAdditionalColumns[0].data;
                const changeCopy = this.changedAdditionalColumns[0].data;
                Object.entries(arppuData).forEach(([key, value]) => {
                    const valueDefault = this.currentBoard.tempData.arrpusDefault[key];
                    if (valueDefault != null && valueDefault !== value) {
                        changeCopy[key] = null;
                    }
                });
                this.applyAdditionalChanges();
                this.isAdditionalColumnsChanged = false;
            },
            deleteChangedAdditionalColumnsValue() {
                const column = this.changedAdditionalColumns[this.currentArppuColumn.columnIndex];
                column.data[this.currentArppuColumn.name] = null;
                this.isAdditionalColumnsChanged =
                    JSON.stringify(this.changedAdditionalColumns[this.currentArppuColumn.columnIndex]) !==
                    JSON.stringify(this.additionalColumns[this.currentArppuColumn.columnIndex]);
                this.currentArppuColumn.name = '';
                this.currentArppuColumn.columnIndex = null;
            },
            initAdditionalColumns() {
                // if (this.shortFeatureName === 'Summary') {
                //     console.log('this.shortFeatureName', _.cloneDeep(this.shortFeatureName));
                //     listenAdditionalDataCb(this.shortFeatureName,()=>{
                //         console.log('test');
                //     });
                // }
            },
            hideSummaryEvents(events) {
                getSummaryEvents().forEach((sumEventName) => {
                    const sumEventIndex = events.findIndex((e) => e.name === sumEventName);
                    if (sumEventIndex >= 0 && !this.featureDeletedIndexes.includes(sumEventIndex)) {
                        if (this.featureSettings.deletedEventsNames) {
                            this.featureSettings.deletedEventsNames.push(sumEventName);
                        }
                    }
                });
            },
            clearData() {
                this.chartData = {
                    datasets: [],
                    labels: [],
                };
                if (this.feature.styles?.columnVisibilityStyles) {
                    this.deleteCssRulesLocal(this.feature.styles.columnVisibilityStyles);
                }
            },
            getAvailableViews() {
                let availableViews = featureViews;
                if (this.feature.name !== 'Summary') {
                    availableViews = availableViews.filter((view) => view.name !== 'Line');
                } else {
                    availableViews = availableViews.filter((view) => view.name !== 'Pie');
                }
                return Object.freeze(availableViews);
            },
            changeFeatureChart(viewIndex) {
                const viewName = this.featureViews[viewIndex].name;
                if (this.featureSettings.featureView !== viewName) {
                    this.$nextTick(() => {
                        this.$emit('changeFeatureViewType', this.feature, 'featureView', viewName);
                    });
                }
            },
            handleGlobalMouseUp() {
                this.clearTableSelection();
            },
            clearTableSelection() {
                this.tableSelection = {
                    start: {
                        columnIndex: null,
                        rowIndex: null,
                    },
                    end: {
                        columnIndex: null,
                        rowIndex: null,
                    },
                    isHeaderSelected: false,
                    active: false,
                };
                this.moveMoveCoortinats = {
                    y: null,
                    x: null,
                };
            },
            checkIfCells(event) {
                return event.target.matches('.VFeatureBlock-data-column') ||
                    event.target.matches('.VFeatureBlock-item__name') || event.target.matches('.VFeatureBlock-headers__name');
            },
            deleteSelection() {
                this.clearTableSelection();
                this.$emit('addSelection', this.shortFeatureName, null);
            },
            handleFeatureMouseDown(event) {
                if (event.button === 0 && !event.ctrlKey && !event.metaKey && !event.shiftKey && this.checkIfCells(event)) {
                    this.clearTableSelection();
                    this.tableSelection.active = true;
                    this.tableSelection.start.columnIndex = Math.max(0, getNodeIndex(event.target) - 1);
                    let row = event.target.parentElement;
                    if (row.classList.contains('row-sector')) {
                      row = row.parentElement;
                    }
                    let rowIndex = null;
                    if (row.matches('.VFeatureBlock-headers')) {
                        this.tableSelection.isHeaderSelected = true;
                    } else {
                        const rowCssClass = [...row.classList].filter((cssClass) =>
                            cssClass.includes('VFeatureBlock'))[1];
                        const rowStartUniqueId = +rowCssClass.split('-')[2];
                        rowIndex = this.datatableItems.findIndex((row) => row.uniqueId === rowStartUniqueId);
                        this.tableSelection.start.rowIndex = rowIndex;
                        this.tableSelection.end.rowIndex = rowIndex;
                    }

                    if (rowIndex >= 0 || this.tableSelection.isHeaderSelected) {
                        event.preventDefault();
                        removeSelection();

                        this.tableSelection.end.columnIndex = this.tableSelection.start.columnIndex;

                        window.addEventListener('mousemove', this.handleFeatureMouseMove);
                        this.$emit('addSelection', this.shortFeatureName, this.datatableItems, this.tableSelection);
                    }

                }
            },
            handleFeatureMouseMove(event) {
                if (!this.moveMoveCoortinats.x) {
                    this.moveMoveCoortinats.y = event.y;
                    this.moveMoveCoortinats.x = event.x;
                    this.handleMoveOnly = false;
                }
                if (Math.abs(this.moveMoveCoortinats.x - event.x) > 4 ||
                    Math.abs(this.moveMoveCoortinats.y - event.y) > 4) {
                    this.handleMoveOnly = true;
                    window.removeEventListener('mousemove', this.handleFeatureMouseMove);
                }
            },
            handleFeatureMouseOver(event) {
              let row = event.target.parentElement;
              if (row.classList.contains('row-sector')) {
                row = row.parentElement;
              }
              let rowIndex = null;
                let datatableRow = null;
                if (this.checkIfCells(event)) {
                    const rowCssClass = [...row.classList].filter((cssClass) =>
                        cssClass.includes('VFeatureBlock'))[1];
                    if (rowCssClass) {
                        const rowEndUniqueId = +rowCssClass.split('-')[2];
                        rowIndex = this.datatableItems.findIndex((row) => row.uniqueId === rowEndUniqueId);
                        datatableRow = this.datatableItems[rowIndex];
                    }
                }
                const summaryNotesIndex = Object.keys(this.summaryNotes).findIndex((date) => date ===
                    datatableRow?.value);
                if (datatableRow && getFeaturesWithRevenueEvents().includes(this.feature.name.toLowerCase()) && summaryNotesIndex >= 0) {
                    this.showTooltip(event, 'instantText',
                        this.currentBoard.summaryNotes[summaryNotesIndex].body.replaceAll('\n', '<br>'));
                }

                window.removeEventListener('mousemove', this.handleFeatureMouseMove);
                if (this.tableSelection.active && this.checkIfCells(event)) {

                    let rowIndex = null;
                    if (!this.tableSelection.isHeaderSelected) {
                        const rowCssClass = [...row.classList].filter((cssClass) =>
                            cssClass.includes('VFeatureBlock'))[1];
                        if (rowCssClass) {
                            const rowEndUniqueId = +rowCssClass.split('-')[2];
                            rowIndex = this.datatableItems.findIndex((row) => row.uniqueId === rowEndUniqueId);
                        }
                    }

                    if (rowIndex >= 0 || this.tableSelection.isHeaderSelected) {
                        removeSelection();

                        const end = {
                          columnIndex: Math.max(0, getNodeIndex(event.target) - 1),
                            rowIndex: rowIndex,
                        };
                        const normalizedSelection = {
                            start: {
                                columnIndex: Math.min(this.tableSelection.start.columnIndex, end.columnIndex),
                                rowIndex: Math.min(this.tableSelection.start.rowIndex, end.rowIndex),
                            },
                            end: {
                                columnIndex: Math.max(this.tableSelection.start.columnIndex, end.columnIndex),
                                rowIndex: Math.max(this.tableSelection.start.rowIndex, end.rowIndex),
                            },
                            isHeaderSelected: this.tableSelection.isHeaderSelected,
                        };
                        this.$emit('addSelection', this.shortFeatureName, this.datatableItems, normalizedSelection);
                    }
                }
            },
            getChartData() {
                if (!this.isTableView && this.feature.rows) {
                    const availableIndexes = [];
                    const eventsNames = this.events.map((event) => event.name);
                    const formulasNames = this.formulas.map((formula) => formula.name);
                    const availableEvents = [];
                    const availableFormulas = [];
                    this.allEvents.forEach((event, eventIndex) => {
                        if (!this.featureDeletedIndexes.includes(eventIndex) && eventsNames.includes(event.name)) {
                            availableIndexes.push(eventIndex);
                            availableEvents.push(event);
                        }
                    });
                    const eventsLength = this.allEvents.length;
                    this.allFormulas.forEach((formula, formulaIndex) => {
                        const currentIndex = eventsLength + formulaIndex;
                        if (!this.featureDeletedIndexes.includes(currentIndex) && formulasNames.includes(formula.name)) {
                            availableIndexes.push(currentIndex);
                            availableFormulas.push(formula);
                        }
                    });
                    const featureView = this.featureSettings.featureView.toLowerCase();
                    const generatedData = generateChartSettings(featureView, this.feature.name, availableIndexes, availableEvents, availableFormulas, this.feature.rows);
                    this.chartData = generatedData.chartData;
                    this.chartOptions = Object.freeze(generatedData.chartOptions);
                    this.$emit('getChartData', this.chartData, this.chartOptions);
                }
            },
            showInput() {
                this.isSearchActive = true;
                setTimeout(() => {
                    this.$nextTick(() => {
                        const el = this.$refs.vinput.$el;
                        el.classList.add('VInput_showed');
                        this.$refs.vinput.$refs.input.focus();
                    });
                }, 4);

            },
            hideInput() {
                if (!this.search.length) {
                    const el = this.$refs.vinput.$el;
                    el.classList.remove('VInput_showed');
                    this.$refs.vinput.$refs.input.focus();
                    setTimeout(() => {
                        this.isSearchActive = false;
                    }, 200);

                }
            },
            getActiveEvents() {
                return Object.freeze(this.allEvents.filter((event, eventIndex) => !this.featureDeletedIndexes.includes(eventIndex) && !this.deletedEventsAndFormulasIndexes.includes(eventIndex)));
            },
            getActiveFormulas() {
                let formulas = this.allFormulas.filter((formula, formulaIndex) =>
                    !this.featureDeletedIndexes.includes(this.allEvents.length + formulaIndex) && !this.deletedEventsAndFormulasIndexes.includes(this.allEvents.length + formulaIndex));
                formulas = formulas.filter((formula) => {
                    if (!formula.featuresNames) {
                        return true;
                    }
                    return formula.featuresNames[this.shortFeatureName.toLowerCase()];
                });
                return Object.freeze(formulas);
            },
            getDeletedEvents(isFromPopup = true) {
                let deletedEvents = this.allEvents.filter((event, eventIndex) =>
                    this.featureDeletedIndexes.includes(eventIndex) && !this.deletedEventsAndFormulasIndexes.includes(eventIndex));
                if (isFromPopup && !getFeaturesWithRevenueEvents().includes(this.feature.name.toLowerCase())) {
                    deletedEvents = deletedEvents.filter((e) => !getSummaryEvents().includes(e.name));
                }
                return Object.freeze(deletedEvents);
            },
            getDeletedFormulas() {
                let deletedFormulas = Object.freeze(this.allFormulas.filter((formula, formulaIndex) =>
                    this.featureDeletedIndexes.includes(this.allEvents.length + formulaIndex) &&
                    !this.deletedEventsAndFormulasIndexes.includes(this.allEvents.length + formulaIndex)));
                deletedFormulas = deletedFormulas.filter((formula) => {
                    if (!formula.featuresNames) {
                        return true;
                    }
                    return formula.featuresNames[this.shortFeatureName.toLowerCase()];
                });
                return Object.freeze(deletedFormulas);
            },
            pressedEnterInSearch() {
                this.datatableItems.forEach((row) => {
                    this.selectRow(row);
                });
            },
            swapColumns() {
                this.calcWidthForColumns();
            },
            filterByName(filterByValueChange = false) {
                if (this.search.length && this.feature.rows) {
                    const searchText = this.search.toLowerCase().trim();
                    this.itemsFiltered.byName = this.feature.rows.filter((row) => {
                        const value = row.value.toLowerCase().trim();
                        const options = [value];
                        if (this.nameAliases && this.nameAliases[value]) {
                            options.push(...this.nameAliases[value]);
                        }
                        return options.some((option) => option.includes(searchText));
                    });
                } else {
                    this.itemsFiltered.byName = this.feature.rows;
                }
                this.filterByValue(this.feature.filterValue.name, this.feature.filterValue.index, filterByValueChange);
            },
            setCurrentArppuColumn(currentArppuColumn) {
                this.currentArppuColumn = currentArppuColumn;
            },
            filterByValue(name, index, change = false) {
                if (this.feature.assignedItems) {
                    if (name) {
                        this.feature.filterValue.name = name;
                    }
                    if (index != null) {
                        this.feature.filterValue.index = index;
                    }
                    delete this.feature.assignedItems;
                    this.filterByName(true);
                } else {
                    if (name) {
                        if (change) {
                            if (this.feature.filterValue.name === name) {
                                this.feature.filterValue.sort = this.feature.filterValue.sort !== 'ascending' ? 'ascending' : 'descending';
                            } else {
                                this.feature.filterValue.sort = 'descending';
                            }
                            this.feature.filterValue.name = name;
                            this.feature.filterValue.index = index;
                        }
                        if (index >= 0) {
                            this.itemsFiltered.byValue = sortPropertyIndex(this.itemsFiltered.byName, 'cells',
                                this.feature.filterValue.sort, index);
                        } else {
                            if (this.dateTypeFeaturesNames.some((featuresNames) => featuresNames.toLowerCase().trim() === this.feature.name.toLowerCase().trim())) {
                                this.itemsFiltered.byValue = sortByPropertyNameForDates(this.itemsFiltered.byName,
                                    'value', this.feature.filterValue.sort);
                            } else if (this.numberTypeFeaturesNames.some((featuresNames) => featuresNames.toLowerCase().trim()
                                === this.feature.name.toLowerCase().trim())) {
                                this.itemsFiltered.byValue = sortByPropertyNameForNumbers(this.itemsFiltered.byName,
                                    'value', this.feature.filterValue.sort);
                            } else {
                                this.itemsFiltered.byValue = sortByPropertyNameForStrings(this.itemsFiltered.byName,
                                    'value', this.feature.filterValue.sort);
                            }
                        }
                    } else {
                        this.itemsFiltered.byValue = this.itemsFiltered.byName;
                    }
                    this.filterByColor(this.feature.selectedColors);
                }
            },
            filterByColor(colors, isForceReloadVirtualItems = false) {
                if (this.feature.assignedItems) {
                    delete this.feature.assignedItems;
                    this.filterByName();
                } else {
                    if (colors.length) {
                        const newItemsFilterByColor = this.itemsFiltered.byValue.filter((item) => colors.includes(item.color));
                        if (newItemsFilterByColor.length) {
                            this.itemsFiltered.byColor = newItemsFilterByColor;
                        } else {
                            this.itemsFiltered.byColor = this.itemsFiltered.byValue;
                        }
                    } else {
                        this.itemsFiltered.byColor = this.itemsFiltered.byValue;
                    }
                    this.assignDatatableItems(this.itemsFiltered.byColor, false, isForceReloadVirtualItems);
                }
            },
            importChartComponent(featureView) {
                const componentType = featureView.toLowerCase().replaceAll(' ', '');
                this.chartComponent = () =>
                    import(`./VFeatureBlock/VFeatureBlockCharts/VFeatureBlockChart-${componentType}.vue`);
            },
            assignDatatableItems(items, isForceUpdateFeature, isForceReloadVirtualItems) {
                this.deleteSelection();
                this.datatableItems = Object.freeze(items);
                if (this.isShowLoadingForCurrentFeature || isForceUpdateFeature) {
                    this.calcWidthForColumns();
                    this.updateColumnVisibilityStyles();
                    this.isShowDatatable = true;
                    this.isShowLoadingForCurrentFeature = false;

                    if (!this.isTableView) {
                        this.getChartData('assignDatatableItems');
                        this.importChartComponent(this.featureSettings.featureView);
                    }

                    if (this.currentBoard.temp && this.currentBoard.temp[this.feature.name] &&
                        this.currentBoard.temp[this.feature.name].newEventsCount) {
                        let additionalWidth = 0.1;
                        for (let i = 0; i < this.currentBoard.temp[this.feature.name].newEventsCount; i++) {
                            additionalWidth += getTableColumnWidth(this.feature.columnsWidth[i]);
                        }
                        if (this.featureSettings.width) {
                            this.featureSettings.width += additionalWidth;
                            delete this.currentBoard.temp[this.feature.name].newEventsCount;
                        }
                    }
                    if (!this.featureSettings.width) {
                        this.$nextTick(() => {
                            this.featureSettings.width = this.$el.getBoundingClientRect().width;
                        });
                    }
                    this.$nextTick(() => {
                        this.feature.areItemsCached = false;
                    });

                }
                if (isForceReloadVirtualItems) {
                    this.$nextTick(() => {
                        this.$refs.virtualtable.getVisibleItems();
                    });
                }
            },
            selectColor(color) {
                if (this.feature.selectedColors.includes(color)) {
                    this.feature.selectedColors = this.feature.selectedColors.filter((fColor) => fColor !== color);
                } else {
                    this.feature.selectedColors.push(color);
                }
                this.filterByColor(this.feature.selectedColors);
            },
            updateColumnVisibilityStyles() {
                if (!this.feature.areItemsCached) {
                    this.deleteCssRulesLocal(this.feature.styles.columnVisibilityStyles);
                    this.feature.styles.columnVisibilityStyles = this.createCssRulesLocal(() => {
                        return this.featureDeletedIndexes.map((index) => {
                            return `${this.shortcutByFeatureClass} .VFeatureBlock-data-column:nth-of-type(${index + 2}) {display: none;}`;
                        });
                    });
                }
            },
            highlightSelectedRows(ids) {
                if (!this.feature.areItemsCached) {
                    this.deleteCssRulesLocal(this.boardStyles.selectedRowsStyles);
                    if (ids.length) {
                        this.boardStyles.selectedRowsStyles = this.createCssRulesLocal(() => {
                            let featureRowStyle = '';
                            let featureRowDataStyle = '';
                            ids.forEach((id, idIndex) => {
                                if (idIndex !== 0) {
                                    featureRowStyle += ',';
                                    featureRowDataStyle += ',';
                                }
                                const featureId = `${this.shortcutByFeatureClass}-${id}`;
                                featureRowStyle += `${featureId}`;
                                featureRowDataStyle += `${featureId}>.VFeatureBlock-data-column`;
                            });
                            featureRowStyle += '{background:#6089E7!important;color:#fff;}';
                            featureRowDataStyle += '{color:#fff!important;}';
                            return [featureRowStyle, featureRowDataStyle];
                        });
                    }
                }
            },
            addColumnWidthForNewFormula() {
                this.calcWidthForColumns();
                // const lastNumber = this.showHeadersNames.length - 1;
                // const numbers = this.feature.rows.map((row) => row.cells[lastNumber]);
                // const maxNumber = Math.max.apply(Math, numbers);
                // const maxNumberWidth = getTextWidth(maxNumber);
                // const headerWidth = getTextWidth(this.showHeadersNames[lastNumber]);
                // const maxWidth = Math.max(maxNumberWidth, headerWidth);
                // this.feature.columnsWidth.push(maxWidth);
                // changeFeatureWidthOnColumnWidth(this.feature, this.featureSettings, this.allEventsAndAllFormulas, this.allEventsAndAllFormulas[this.allEventsAndAllFormulas.length - 1].name, 1);
                // this.setColumnsWidthStyles();
                // this.filterByName();
            },
            deleteColumnWidthForNewFormula() {
                this.calcWidthForColumns();
                // const lastNumber = this.showHeadersNames.length - 1;
                // const numbers = this.feature.rows.map((row) => row.cells[lastNumber]);
                // const maxNumber = Math.max.apply(Math, numbers);
                // const maxNumberWidth = getTextWidth(maxNumber);
                // const headerWidth = getTextWidth(this.showHeadersNames[lastNumber]);
                // const maxWidth = Math.max(maxNumberWidth, headerWidth);
                // this.feature.columnsWidth.push(maxWidth);
                // changeFeatureWidthOnColumnWidth(this.feature, this.featureSettings, this.allEventsAndAllFormulas,
                //     this.allEventsAndAllFormulas[this.allEventsAndAllFormulas.length - 1].name, -1);
                // this.setColumnsWidthStyles();
                // this.filterByName();
            },
            updateColumnWidthForFormula(rowColumnIndex) {
                const numbers = this.feature.rows.map((row) => row.cells[rowColumnIndex]);
                const maxNumber = Math.max.apply(Math, numbers);
                const maxNumberWidth = getTextWidth(maxNumber);
                const headerWidth = getTextWidth(this.showHeadersNames[rowColumnIndex]);
                const maxWidth = Math.max(maxNumberWidth, headerWidth);
                this.feature.columnsWidth[rowColumnIndex] = maxWidth;
                this.setColumnsWidthStyles();
                this.filterByName();
            },
            calcWidthForColumns() {
                if (this.feature.rows) {
                    const items = this.feature.rows;
                    const sumRows = this.feature.sumRows;
                    const columnsWidth = [];
                    this.headersWidth.forEach((headerWidth, headerIndex) => {
                      const itemsCells = items.flatMap(item => [
                        item.cells[headerIndex],
                        ...item.subrows.map(subrow => subrow.cells[headerIndex])
                      ]);

                        let itemsWidth = 0;
                        let sumRowsWidth = 0;
                        if (itemsCells.length) {
                            const longestItem = itemsCells.reduce(
                                function (a, b) {
                                    return String(a).length > String(b).length ? a : b;
                                },
                            );

                            itemsWidth = getTextWidth(longestItem);
                            if (sumRows) {
                                const sumRowsNumbers = sumRows.length ? sumRows.map((sumRow) => sumRow.cells[headerIndex]) : [0];
                                const longestSumItem = sumRowsNumbers.reduce(
                                    function (a, b) {
                                        return String(a).length > String(b).toString().length ? a : b;
                                    },
                                );
                                sumRowsWidth = getTextWidth(longestSumItem);
                            }
                        }
                        columnsWidth.push(Math.max(itemsWidth, headerWidth, sumRowsWidth));
                    });

                    const columnsWidthSum = getTableColumnWidthActiveColumns(columnsWidth, this.currentBoard.deletedEventsAndFormulasIndexes.concat(this.featureDeletedIndexes));

                    const paddingsLeft = 20;
                    const nameWidth = this.featureSettings.nameWidth ? this.featureSettings.nameWidth : 54;
                    let additionalColumnsWidth = 0;
                    if (this.additionalColumns) {
                        additionalColumnsWidth = this.additionalColumns.reduce((sum, column) => {
                            sum += column.width;
                            return sum;
                        }, 0);
                    }
                    this.featureSettings.width = columnsWidthSum + nameWidth + paddingsLeft + additionalColumnsWidth;
                    this.feature.columnsWidth = columnsWidth;
                    this.setColumnsWidthStyles();
                }
            },
            setColumnsWidthStyles() {
                if (this.feature.styles && this.feature.styles.columnsWidthStyles !== null &&
                    !this.feature.areItemsCached) {
                    this.deleteCssRulesLocal(this.feature.styles.columnsWidthStyles);
                    this.feature.styles.columnsWidthStyles = this.createCssRulesLocal(() => {
                        return this.feature.columnsWidth.map((width, widthIndex) => {
                            return `${this.shortcutByFeatureClass} .VFeatureBlock-data-column:nth-of-type(${widthIndex + 2}) {width:${width}px}`;
                        });
                    });
                }
            },
            deleteColumnsStyles() {
                if (this.feature.styles) {
                    this.deleteCssRulesLocal(this.feature.styles.columnsWidthStyles);
                    this.deleteCssRulesLocal(this.feature.styles.columnVisibilityStyles);
                }
            },
            removeEvent(event) {
                changeFeatureWidthOnColumnWidth(this.feature, this.featureSettings, this.allEventsAndAllFormulas, event.name, -1);
                if (!this.featureSettings.deletedEventsNames) {
                    this.$set(this.featureSettings, 'deletedEventsNames', []);
                }

                this.featureSettings.deletedEventsNames.push(event.name);
                this.updateAfterEventsFormulaChange();
            },
            removeFormula(formula) {
                changeFeatureWidthOnColumnWidth(this.feature, this.featureSettings, this.allEventsAndAllFormulas, formula.name, -1);
                if (!this.featureSettings.deletedEventsNames) {
                    this.$set(this.featureSettings, 'deletedEventsNames', []);
                }
                this.featureSettings.deletedFormulasNames.push(formula.name);
                this.updateAfterEventsFormulaChange();
            },
            addEvent(event) {
                if (event.name.startsWith("revenue") && event.name.length > 7) {
                  this.featureSettings.showRevenues = true;
                }
                changeFeatureWidthOnColumnWidth(this.feature, this.featureSettings, this.allEventsAndAllFormulas, event.name, 1);
                if (!this.featureSettings.deletedEventsNames) {
                    this.$set(this.featureSettings, 'deletedEventsNames', []);
                }
                this.featureSettings.deletedEventsNames = this.featureSettings.deletedEventsNames.filter((name) =>
                    name !== event.name);
                this.updateAfterEventsFormulaChange();
            },
            addFormula(formula) {
                changeFeatureWidthOnColumnWidth(this.feature, this.featureSettings, this.allEventsAndAllFormulas, formula.name, 1);
                if (!this.featureSettings.deletedEventsNames) {
                    this.$set(this.featureSettings, 'deletedEventsNames', []);
                }
                this.featureSettings.deletedFormulasNames = this.featureSettings.deletedFormulasNames.filter((name) =>
                    name !== formula.name);
                this.updateAfterEventsFormulaChange();
            },
            updateAfterEventsFormulaChange() {
                this.fixSettingsDropdownIntersection();
                if (!this.isTableView) {
                    this.getChartData('updateAfterEventsFormulaChange');
                }
            },
            closeFeature() {
                if (this.isLoadedFromPopup) {
                    this.$emit('hideTablePopup');
                } else {
                    this.$emit('closeFeature');
                }

            },
            selectRow(row) {
                this.$emit('selectRow', this.featureIndex, row.uniqueId);
            },
            sumRows() {
                this.$emit('sumRows', this.featureIndex);
            },
            deleteSumRow(index) {
                this.$emit('deleteSumRow', this.featureIndex, index);
            },
            selectAllRowExceptClicked(row) {
                if (this.feature.name !== 'Summary') {
                    this.$emit('selectAllRowExceptClicked', this.featureIndex, row.uniqueId);
                }
            },
            selectRowWithShift(row, rowIndex) {
                this.$emit('selectRowWithShift', this.featureIndex, row.uniqueId, rowIndex);
            },
            filterClickedRow(row, filterType) {
                if (this.isNotSummaryTable && !this.handleMoveOnly) {
                    const rowIndexFromDefaultArray = this.feature.rows.findIndex((defaultRow) => defaultRow.uniqueId === row.uniqueId);
                    this.$emit('filterClickedRow', this.featureIndex, rowIndexFromDefaultArray, filterType);
                } else if (!this.isNotSummaryTable && !this.handleMoveOnly) {
                    const rowIndexFromDefaultArray = this.feature.rows.findIndex((defaultRow) => defaultRow.uniqueId === row.uniqueId);
                    this.$emit('filterClickedRowSummaryTable', this.featureIndex, rowIndexFromDefaultArray);
                } else {
                    this.handleMoveOnly = false;
                }
            },
            showFeatureSettingsVisibility() {
                this.isSettingsActive = true;
                this.savedData = {
                    deletedIndexes: _.cloneDeep(this.featureDeletedIndexes),
                };
            },
            hideFeatureSettingsVisibility() {
                this.isSettingsActive = false;

                const isEventOrFormulasChanged = !areArraysEqual(this.savedData.deletedIndexes, this.featureDeletedIndexes);
                if (isEventOrFormulasChanged) {
                    const newFeatureSettings = {
                        deletedEventsNames: this.getDeletedEvents(false).map((event) => event.name),
                        deletedFormulasNames: this.getDeletedFormulas().map((formulas) => formulas.name),
                    };
                    setTimeout(() => {
                        this.$emit('updateFeatureSettingsByProperties', this.feature.name, newFeatureSettings);
                    }, 4);

                }
            },
            showFeatureColorPickerVisibility() {
                if (this.areRowsSelected) {
                    this.isColorPickerActive = true;
                }
            },
            hideFeatureColorPickerVisibility() {
                this.isColorPickerActive = false;
            },
            changeSelectColor(color) {
                this.isColorPickerActive = false;
                this.$emit('applySelection', this.featureIndex, color);
            },
            download() {
                const exportRows = [];
                exportRows.push(['name', ...this.headersNames]);
                if (this.areRowsSelected) {
                    this.datatableItems.filter((row) => this.feature.selectedIds.includes(row.uniqueId)).forEach((row) =>
                        exportRows.push([row.value.replace(/,/g, '.'),
                            ...row.cells]));
                } else {
                    this.datatableItems.forEach((row) => exportRows.push([row.value.replace(/,/g, ' '), ...row.cells]));
                }
                exportRowsToFile('selected', exportRows);
            },
            showTooltip(event, tooltipFunction, data) {
                this.$emit('showTooltip', event, tooltipFunction, data);
            },
            fixSettingsDropdownIntersection() {
                this.$nextTick(() => {
                    fixBlockIntersection(this.$el.querySelector('.VFeatureBlock-settings-dropdown-block'), {left: 0});
                });
            },
            swapFeatureColumns(swapFirstIndex, swapSecondIndex) {
                [this.feature.columnsWidth[swapFirstIndex], this.feature.columnsWidth[swapSecondIndex]] = [this.feature.columnsWidth[swapSecondIndex], this.feature.columnsWidth[swapFirstIndex]];
                this.setColumnsWidthStyles();
            },
            showFeaturesLoadings(visibility = true) {
                this.isShowLoadingForCurrentFeature = visibility;
            },
            createCssRulesLocal(callback) {
                return createCssRules.call(this, callback);
            },
            deleteCssRulesLocal(cssStyleObj) {
                deleteCssRules.call(this, cssStyleObj);
            },
            showChartPopup() {
                this.$emit('showChartPopup', this.chartComponent, this.chartData, this.chartOptions, this.feature.name);
            },
            showTablePopup() {
                this.$emit('showTablePopup', this.feature);
            },
        },
    };
</script>

<style
    scoped
    lang="scss"
>
  .VFeatureBlock {
    //border: 2px solid #FFFFFF;
    border-radius: 10px;
    text-align: left;
    max-height: 450px;
    height: 100%;
    background-color: #FFFFFF;
    position: relative;
    border-right: 4px solid #fff;
    min-width: 350px;
    @include dark-shadow;

    .column-button {
      margin-right: 6px;
      display: flex;

      ::v-deep {
        .VButton {
          margin-right: 5px;

          &__title {
            margin-right: 0;
          }
        }
      }
    }

    &-chart {
      padding: 0 0 0 4px;

      ::v-deep canvas {
        max-height: 370px;
      }
    }

    &-wrapper {
      margin: 10px;

      &_resized {
        .VFeatureBlock {
          border-right: 4px solid #6089E7 !important;

          &-chart {
            padding-right: 3px;
          }
        }
      }
    }

    &_resized {
      opacity: .5;
    }

    &_highlight {
      .VFeatureBlock {
        border: 2px solid $primary-color;
        margin: -2px;

        &-title-bar {
          border-radius: 6px 6px 0 0;
        }
      }

    }

    &-filter {
      &-icon {
        background: url("/icons/components/VFeatureBlock/icon_sort.svg");
        width: 21px;
        height: 20px;

        &:hover {
          background: url("/icons/components/VFeatureBlock/icon_sort_hover.svg");
        }
      }
    }

    ::v-deep .resizers {
      display: contents;

      .resizer {
        width: 9px;

        height: 100%;
        /* border-radius: 50%; */
        //background: red;
        top: 0;
        position: absolute;
        //top: 50%;
        //transform: translateY(-50%);
        cursor: e-resize;
        z-index: 5;

        &.left {
          left: 0;

        }

        &.right {
          right: -5px;
        }
      }

    }

    &-Summary {
      ::v-deep .VFeatureBlock {
        background-color: #F3F5FC;
        border-right: 4px solid #F3F5FC;
        //border: 2px solid #F3F5FC;
        &-item {
          box-shadow: none;
        }

        &-title-bar {
          padding-right: 195px;
        }

        &-headers-background {
          background-color: #F3F5FC;

          &-scroll {
            background-color: #F3F5FC;
          }
        }
      }

      ::v-deep .VFeatureVirtualTable {
        .root {
          @include scrollbar-features-summary-styles;
        }
      }

    }

    &-color-picker {
      position: relative;

      &-icon {
        width: 18px;
        height: 18px;
        background-position: 0 0;
        background-repeat: no-repeat;
        background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjE4cHgiIGhlaWdodD0iMThweCIgdmlld0JveD0iMCAwIDE4IDE4IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDx0aXRsZT5BRDExODVBNi0zQzYwLTRERUMtQUVGQS0wQTIwRjdCMjQwODBAMSw1eDwvdGl0bGU+DQogICAgPGcgaWQ9IlBhZ2UtNCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgICAgIDxnIGlkPSJBcnRib2FyZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIyLjAwMDAwMCwgLTM0NS4wMDAwMDApIiBmaWxsPSIjMDJERkIwIiBzdHJva2U9IiM2MDg5RTciPg0KICAgICAgICAgICAgPGcgaWQ9IlJlY3RhbmdsZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjMuMDAwMDAwLCAzNDYuMDAwMDAwKSI+DQogICAgICAgICAgICAgICAgPHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjYiIGhlaWdodD0iNiIgcng9IjEiPjwvcmVjdD4NCiAgICAgICAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMCIgd2lkdGg9IjYiIGhlaWdodD0iNiIgcng9IjEiPjwvcmVjdD4NCiAgICAgICAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSI2IiBoZWlnaHQ9IjYiIHJ4PSIxIj48L3JlY3Q+DQogICAgICAgICAgICAgICAgPHJlY3QgeD0iMCIgeT0iMTAiIHdpZHRoPSI2IiBoZWlnaHQ9IjYiIHJ4PSIxIj48L3JlY3Q+DQogICAgICAgICAgICA8L2c+DQogICAgICAgIDwvZz4NCiAgICA8L2c+DQo8L3N2Zz4=');
      }

      &-dropdown-icon {
        border-radius: 5px 5px 0 0;
        width: 18px;
        height: 18px;
        cursor: pointer;
        position: absolute;
        right: 0;
        top: -33px;
        background-color: #ffffff;
        padding: 10px 9px;
        padding-bottom: 6px;
        box-shadow: 0 1px 6px 0 #aebff1;
        background-position: center 10px;
        background-repeat: no-repeat;
        background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjE4cHgiIGhlaWdodD0iMThweCIgdmlld0JveD0iMCAwIDE4IDE4IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDx0aXRsZT5BRDExODVBNi0zQzYwLTRERUMtQUVGQS0wQTIwRjdCMjQwODBAMSw1eDwvdGl0bGU+DQogICAgPGcgaWQ9IlBhZ2UtNCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgICAgIDxnIGlkPSJBcnRib2FyZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIyLjAwMDAwMCwgLTM0NS4wMDAwMDApIiBmaWxsPSIjMDJERkIwIiBzdHJva2U9IiM2MDg5RTciPg0KICAgICAgICAgICAgPGcgaWQ9IlJlY3RhbmdsZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjMuMDAwMDAwLCAzNDYuMDAwMDAwKSI+DQogICAgICAgICAgICAgICAgPHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjYiIGhlaWdodD0iNiIgcng9IjEiPjwvcmVjdD4NCiAgICAgICAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMCIgd2lkdGg9IjYiIGhlaWdodD0iNiIgcng9IjEiPjwvcmVjdD4NCiAgICAgICAgICAgICAgICA8cmVjdCB4PSIxMCIgeT0iMTAiIHdpZHRoPSI2IiBoZWlnaHQ9IjYiIHJ4PSIxIj48L3JlY3Q+DQogICAgICAgICAgICAgICAgPHJlY3QgeD0iMCIgeT0iMTAiIHdpZHRoPSI2IiBoZWlnaHQ9IjYiIHJ4PSIxIj48L3JlY3Q+DQogICAgICAgICAgICA8L2c+DQogICAgICAgIDwvZz4NCiAgICA8L2c+DQo8L3N2Zz4=');


        &::after {
          content: "";
          width: 42px;
          height: 10px;
          background: #ffffff;
          position: absolute;
          bottom: -9px;
          z-index: 10;
          right: 0px;
        }
      }

      &-dropdown {
        border-radius: 5px;
        cursor: default;
        position: absolute;
        display: flex;
        padding: 10px 4px 5px 9px;
        background: #FFFFFF;
        width: 85px;
        right: -9px;
        top: 23px;
        flex-wrap: wrap;
        z-index: $dropdown-z-index;
        @include settings-popup-shadow;


        &__block {
          border-radius: 2px;
          width: 16px;
          height: 16px;
          cursor: pointer;
          opacity: .65;
          margin: 0 5px 5px 0;

          &:first-child {
            margin: 0;
          }

          &_close {
            border: 1px solid $primary-color;
            position: relative;
            width: 14px;
            height: 14px;

            &:after, &:before {
              position: absolute;
              content: '';
              background: $primary-color;
              display: block;
              width: 100%;
              height: 2px;
              -webkit-transform: rotate(-45deg);
              transform: rotate(-45deg);
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              margin: auto;
            }

            &:after {
              -webkit-transform: rotate(45deg);
              transform: rotate(45deg);
            }
          }
        }
      }
    }

    &-settings {
      width: 18px;
      height: 18px;
      position: relative;

      &-icon {
        width: 18px;
        height: 18px;
        background-position: 0 0;
        background-repeat: no-repeat;
        background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjE4cHgiIGhlaWdodD0iMThweCIgdmlld0JveD0iMCAwIDE4IDE4IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDwhLS0gR2VuZXJhdG9yOiBza2V0Y2h0b29sIDU1LjIgKDc4MTgxKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4NCiAgICA8dGl0bGU+RkU1MkFBNzktRjMzMS00RUNDLTk4RTYtMzNGQUFDNTJBMzlEQDEsNXg8L3RpdGxlPg0KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4NCiAgICA8ZyBpZD0iUGFnZS00IiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4NCiAgICAgICAgPGcgaWQ9Ik1haW5fcGxhaW5fb3Blbl9ldmVudHMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC03MDIuMDAwMDAwLCAtMjU5LjAwMDAwMCkiIGZpbGw9IiMwMkRGQjAiIHN0cm9rZT0iIzYwODlFNyI+DQogICAgICAgICAgICA8ZyBpZD0idGFibGVzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4MC4wMDAwMDAsIDI0MC4wMDAwMDApIj4NCiAgICAgICAgICAgICAgICA8ZyBpZD0idGFibGVfMSI+DQogICAgICAgICAgICAgICAgICAgIDxnIGlkPSJ0YWJsZV9pbm5lcl9oZWFkZXIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLCAxNS4wMDAwMDApIj4NCiAgICAgICAgICAgICAgICAgICAgICAgIDxnIGlkPSJpY29uL3Rvb2wiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDYyMy4wMDAwMDAsIDUuMDAwMDAwKSI+DQogICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTYuNDk2MjQwNiwyLjEzMjcyMzA4IEw2LjQ5NjI0MDYsMS42MjQwNjAxNSBDNi40OTYyNDA2LDAuNzI3MTE2NDk3IDcuMjIzMzU3MSwxLjY0NzY1ODc2ZS0xNiA4LjEyMDMwMDc1LDAgQzkuMDE3MjQ0NDEsLTEuNjQ3NjU4NzZlLTE2IDkuNzQ0MzYwOSwwLjcyNzExNjQ5NyA5Ljc0NDM2MDksMS42MjQwNjAxNSBMOS43NDQzNjA5LDIuMTMyNzIzMDggQzEwLjI1Mjk1MDIsMi4yNjkwMzg4MyAxMC43MzU0MTMzLDIuNDY3ODIzNTMgMTEuMTgyNzMzOSwyLjcyMDE5NDQ5IEwxMS41NjU0NTI2LDIuMzQzMTQ1NzUgQzEyLjIwMjQ0MTIsMS43MTU1OTQgMTMuMjI1MjMxOSwxLjcxNTU5NCAxMy44NjIyMjA1LDIuMzQzMTQ1NzUgQzE0LjQ4NzA1OTMsMi45NTg3Mjc3NSAxNC40OTQ1NjM1LDMuOTY0Mjg3NTMgMTMuODc4OTgxNSw0LjU4OTEyNjQgQzEzLjg3MzQzNjMsNC41OTQ3NTUwMyAxMy44Njc4NDkxLDQuNjAwMzQyMjEgMTMuODYyMjIwNSw0LjYwNTg4NzQ1IEwxMy40Nzk1MDE4LDQuOTgyOTM2MTkgQzEzLjczNTY2NzgsNS40MjM2Mjk4NCAxMy45Mzc0NDE4LDUuODk4OTQ1MzQgMTQuMDc1ODA3NCw2LjQgTDE0LjY0MDYwMTUsNi40IEMxNS41MjQyNTcxLDYuNCAxNi4yNDA2MDE1LDcuMTE2MzQ0NCAxNi4yNDA2MDE1LDggQzE2LjI0MDYwMTUsOC44ODM2NTU2IDE1LjUyNDI1NzEsOS42IDE0LjY0MDYwMTUsOS42IEwxNC4wNzU4MDc0LDkuNiBDMTMuOTM3NDQxOCwxMC4xMDEwNTQ3IDEzLjczNTY2NzgsMTAuNTc2MzcwMiAxMy40Nzk1MDE4LDExLjAxNzA2MzggTDEzLjg2MjIyMDUsMTEuMzk0MTEyNSBDMTQuNDg3MDU5MywxMi4wMDk2OTQ1IDE0LjQ5NDU2MzUsMTMuMDE1MjU0MyAxMy44Nzg5ODE1LDEzLjY0MDA5MzIgQzEzLjg3MzQzNjMsMTMuNjQ1NzIxOCAxMy44Njc4NDkxLDEzLjY1MTMwOSAxMy44NjIyMjA1LDEzLjY1Njg1NDIgQzEzLjIyNTIzMTksMTQuMjg0NDA2IDEyLjIwMjQ0MTIsMTQuMjg0NDA2IDExLjU2NTQ1MjYsMTMuNjU2ODU0MiBMMTEuMTgyNzMzOSwxMy4yNzk4MDU1IEMxMC43MzU0MTMzLDEzLjUzMjE3NjUgMTAuMjUyOTUwMiwxMy43MzA5NjEyIDkuNzQ0MzYwOSwxMy44NjcyNzY5IEw5Ljc0NDM2MDksMTQuMzc1OTM5OCBDOS43NDQzNjA5LDE1LjI3Mjg4MzUgOS4wMTcyNDQ0MSwxNiA4LjEyMDMwMDc1LDE2IEM3LjIyMzM1NzEsMTYgNi40OTYyNDA2LDE1LjI3Mjg4MzUgNi40OTYyNDA2LDE0LjM3NTkzOTggTDYuNDk2MjQwNiwxMy44NjcyNzY5IEM1Ljk4NzY1MTI5LDEzLjczMDk2MTIgNS41MDUxODgxOCwxMy41MzIxNzY1IDUuMDU3ODY3NTYsMTMuMjc5ODA1NSBMNC42NzUxNDg5MiwxMy42NTY4NTQyIEM0LjAzODE2MDI5LDE0LjI4NDQwNiAzLjAxNTM2OTY1LDE0LjI4NDQwNiAyLjM3ODM4MTAyLDEzLjY1Njg1NDIgQzEuNzUzNTQyMTYsMTMuMDQxMjcyMyAxLjc0NjAzNzk4LDEyLjAzNTcxMjUgMi4zNjE2MTk5OCwxMS40MTA4NzM2IEMyLjM2NzE2NTIyLDExLjQwNTI0NSAyLjM3Mjc1MjM5LDExLjM5OTY1NzggMi4zNzgzODEwMiwxMS4zOTQxMTI1IEwyLjc2MTA5OTY3LDExLjAxNzA2MzggQzIuNTA0OTMzNjYsMTAuNTc2MzcwMiAyLjMwMzE1OTcxLDEwLjEwMTA1NDcgMi4xNjQ3OTQxLDkuNiBMMS42LDkuNiBDMC43MTYzNDQ0LDkuNiAtMS43NDA4Mjk3ZS0xMyw4Ljg4MzY1NTYgLTEuNzQwODI5N2UtMTMsOCBDLTEuNzQwODI5N2UtMTMsNy4xMTYzNDQ0IDAuNzE2MzQ0NCw2LjQgMS42LDYuNCBMMi4xNjQ3OTQxLDYuNCBDMi4zMDMxNTk3MSw1Ljg5ODk0NTM0IDIuNTA0OTMzNjYsNS40MjM2Mjk4NCAyLjc2MTA5OTY3LDQuOTgyOTM2MTkgTDIuMzc4MzgxMDIsNC42MDU4ODc0NSBDMS43NTM1NDIxNiwzLjk5MDMwNTQ2IDEuNzQ2MDM3OTgsMi45ODQ3NDU2NyAyLjM2MTYxOTk4LDIuMzU5OTA2OCBDMi4zNjcxNjUyMiwyLjM1NDI3ODE3IDIuMzcyNzUyMzksMi4zNDg2OTEgMi4zNzgzODEwMiwyLjM0MzE0NTc1IEMzLjAxNTM2OTY1LDEuNzE1NTk0IDQuMDM4MTYwMjksMS43MTU1OTQgNC42NzUxNDg5MiwyLjM0MzE0NTc1IEw1LjA1Nzg2NzU2LDIuNzIwMTk0NDkgQzUuNTA1MTg4MTgsMi40Njc4MjM1MyA1Ljk4NzY1MTI5LDIuMjY5MDM4ODMgNi40OTYyNDA2LDIuMTMyNzIzMDggWiBNOC4xMjAzMDA3NSwxMS41MiBDMTAuMDkzNTc2OCwxMS41MiAxMS42OTMyMzMxLDkuOTQ0MDQyMzIgMTEuNjkzMjMzMSw4IEMxMS42OTMyMzMxLDYuMDU1OTU3NjggMTAuMDkzNTc2OCw0LjQ4IDguMTIwMzAwNzUsNC40OCBDNi4xNDcwMjQ3MSw0LjQ4IDQuNTQ3MzY4NDIsNi4wNTU5NTc2OCA0LjU0NzM2ODQyLDggQzQuNTQ3MzY4NDIsOS45NDQwNDIzMiA2LjE0NzAyNDcxLDExLjUyIDguMTIwMzAwNzUsMTEuNTIgWiI+PC9wYXRoPg0KICAgICAgICAgICAgICAgICAgICAgICAgPC9nPg0KICAgICAgICAgICAgICAgICAgICA8L2c+DQogICAgICAgICAgICAgICAgPC9nPg0KICAgICAgICAgICAgPC9nPg0KICAgICAgICA8L2c+DQogICAgPC9nPg0KPC9zdmc+');
      }

      span {
        svg {
          pointer-events: none;
        }
      }

      &-dropdown {
        &-label {
          font-weight: 600;
          padding-top: 4px;
          margin-bottom: 10px;
        }

        &-icon {
          border-radius: 5px;
          width: 18px;
          height: 18px;
          cursor: pointer;
          position: absolute;
          right: 0;
          top: -35px;
          background-color: #ffffff;
          padding: 10px 9px;
          box-shadow: 0 1px 6px 0 #aebff1;
          background-position: center;
          background-repeat: no-repeat;
          background-image: url('data:image/svg+xml;base64,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');


          &::after {
            content: "";
            width: 36px;
            height: 10px;
            background: #ffffff;
            position: absolute;
            bottom: 0;
            z-index: 10;
            right: 0;
          }
        }

        cursor: default;
        right: -9px;
        top: 25px;
        position: absolute;
        z-index: $dropdown-top-z-index;

        &-block {
          border-radius: 5px;
          min-width: 300px;
          padding: 10px;
          display: flex;
          flex-direction: column;
          height: auto;
          max-width: 600px;
          background-color: #FFFFFF;
          z-index: $dropdown-top-z-index;
          position: relative;
          //transform: translate(10px, calc(-100% - 36px));
          @include settings-popup-shadow;
        }
      }
    }

    &-title-bar {
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
      height: 58px;
      align-items: center;
      border-radius: 10px 10px 0 0;
      padding-right: 145px;

      &__name {
        color: #000F48;
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 20px;
        text-transform: capitalize;
        margin-right: 8px;
        display: flex;
      }

      &__name-and-color {
        display: flex;
        align-items: center;
        margin-right: 15px;
        position: relative;
        z-index: 1;
      }

      &__colors {
        display: flex;
      }

      &__color {
        border-radius: 2px;
        height: 15px;
        width: 15px;
        opacity: .65;
        margin-right: 5px;

        &:last-child {
          margin-right: 0;
        }

        &_active {
          @include dark-shadow;

          .VFeatureBlock-title-bar__color {
            @include pressed-button-shadow;
          }


        }

        &_noselected {
          background: #fff;
          height: 13px;
          width: 13px;
          border: 1px solid $primary-color;
        }
      }

      &__color-wrapper {
        margin-right: 5px;

        &:last-child {
          margin-right: 0;
        }
      }

      &__mark {
        width: 20px;
        height: 20px;
        margin-right: 10px;
        display: flex;
        align-items: center;
        justify-content: center;

        &-dropdown {
          border-radius: 5px;
          cursor: default;
          position: absolute;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          padding: 10px 4px 5px 9px;
          background: #FFFFFF;
          right: 115px;
          top: 25px;
          -ms-flex-wrap: wrap;
          flex-wrap: wrap;
          width: 400px;
          z-index: 9;
          @include settings-popup-shadow;

          &-settings {
            display: flex;
            justify-content: space-between;
            width: 100%;
            margin-bottom: 10px;

            span {
              cursor: pointer;
            }

            svg {
              font-size: 20px;
              margin-right: 20px;

            }
          }
        }
      }

      &__popup {
        width: 20px;
        height: 30px;
        margin-right: 10px;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        background-image: url('data:image/png;base64,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');
      }

      &__settings {
        display: flex;
        align-items: center;
        height: 30px;
        position: absolute;
        top: 14px;
        right: 20px;
        cursor: pointer;

        svg {
          pointer-events: none;
        }

        .VSearch-wrapper, .VFeatureBlock-color-picker, .VFeatureBlock-download-icon, .VFeatureBlock-settings, .precision-select {
          margin-right: 10px;
        }
      }
    }

    &-headers {
      &-background {
        height: 24px;
        width: calc(100% - 10px);
        position: absolute;
        z-index: 4;
        top: 53px;
        background: white;

        &-border {
          height: 1px;
          width: 100%;
          position: absolute;
          z-index: 6;
          top: 83px;
          background: $primary-color;
        }

      }
    }

    &-loading {
      width: 500px;
      @include dark-shadow;
      border-radius: 10px;
      overflow: hidden;

      &-title-bar {
        background-color: #F3F6FF;
        height: 53px;
        width: calc(100% - 40px);
        border-bottom: 1px solid #E4ECFF;
        border-radius: 10px 10px 0 0;
        padding: 20px;
        display: flex;
        flex-direction: column;
      }

      &-body {
        background-color: #F3F6FF;
        width: calc(100% - 40px);
        padding: 20px;
        display: flex;
        flex-direction: column;
        border-radius: 0px 0px 10px 10px;
        height: 100%;

        .VFeatureBlock-loading-row {
          margin-bottom: 20px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }

      &-row {
        margin-bottom: 15px;
        height: 20px;
        background: #E4ECFF;
        border-radius: 2px;
        @include loading-animation;

        &:last-child {
          margin-bottom: 0;
        }

        &_small {
          width: 150px;
        }

        &_big {
          width: 100%;
        }
      }
    }

    &-download-icon {
      width: 11px;
      height: 18px;
      background-position: 0 0;
      background-repeat: no-repeat;
      background-image: url('data:image/svg+xml;base64,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');
    }

    &-close-icon {
      width: 17px;
      height: 17px;
      background-position: 0 0;
      background-repeat: no-repeat;
      background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjE3cHgiIGhlaWdodD0iMTdweCIgdmlld0JveD0iMCAwIDE3IDE3IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDx0aXRsZT41QzJERjVGNi01QzAwLTRFQjctQTBBMS0wQUJEMDc4NDdERTFAMSw1eDwvdGl0bGU+DQogICAgPGcgaWQ9IlBhZ2UtNCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgICAgIDxnIGlkPSJBcnRib2FyZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIzLjAwMDAwMCwgLTQ0NC4wMDAwMDApIiBmaWxsPSIjMDJERkIwIiBzdHJva2U9IiM2MDg5RTciPg0KICAgICAgICAgICAgPGcgaWQ9Imljb24vY2xvc2UiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI0LjAwMDAwMCwgNDQ1LjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xLjcwNzEwNjc4LDAuMjkyODkzMjE5IEw3LjQ1OSw2LjA0NSBMMTMuMTA1ODgwOCwwLjM5OTIyNTA2NiBDMTMuNTAyMjc3NiwwLjAwMjgyODIyODEyIDE0LjE0NDk2MzksMC4wMDI4MjgyMjgxMiAxNC41NDEzNjA3LDAuMzk5MjI1MDY2IEMxNC45Mzc3NTc1LDAuNzk1NjIxOTAzIDE0LjkzNzc1NzUsMS40MzgzMDgxNiAxNC41NDEzNjA3LDEuODM0NzA1IEw4Ljg5NSw3LjQ4IEwxNC42NDc2OTI1LDEzLjIzMzQ3OSBDMTUuMDM4MjE2OCwxMy42MjQwMDMzIDE1LjAzODIxNjgsMTQuMjU3MTY4MiAxNC42NDc2OTI1LDE0LjY0NzY5MjUgQzE0LjI1NzE2ODIsMTUuMDM4MjE2OCAxMy42MjQwMDMzLDE1LjAzODIxNjggMTMuMjMzNDc5LDE0LjY0NzY5MjUgTDcuNDgsOC44OTUgTDEuODM0NzA1LDE0LjU0MTM2MDcgQzEuNDM4MzA4MTYsMTQuOTM3NzU3NSAwLjc5NTYyMTkwMywxNC45Mzc3NTc1IDAuMzk5MjI1MDY2LDE0LjU0MTM2MDcgQzAuMDAyODI4MjI4MTIsMTQuMTQ0OTYzOSAwLjAwMjgyODIyODEyLDEzLjUwMjI3NzYgMC4zOTkyMjUwNjYsMTMuMTA1ODgwOCBMNi4wNDUsNy40NTkgTDAuMjkyODkzMjE5LDEuNzA3MTA2NzggQy0wLjA5NzYzMTA3MjksMS4zMTY1ODI0OSAtMC4wOTc2MzEwNzI5LDAuNjgzNDE3NTExIDAuMjkyODkzMjE5LDAuMjkyODkzMjE5IEMwLjY4MzQxNzUxMSwtMC4wOTc2MzEwNzI5IDEuMzE2NTgyNDksLTAuMDk3NjMxMDcyOSAxLjcwNzEwNjc4LDAuMjkyODkzMjE5IFoiPjwvcGF0aD4NCiAgICAgICAgICAgIDwvZz4NCiAgICAgICAgPC9nPg0KICAgIDwvZz4NCjwvc3ZnPg==');
    }
  }

  @supports (-moz-appearance:none) {
    .VFeatureBlock-headers-background {
      width: calc(100% - 7px);

      &-border {
        left: 7px;
        width: calc(100% - 14px);
      }
    }
  }

  .VSearch {
    pointer-events: none;

    &-icon {
      pointer-events: all;
    }

    &-wrapper {
      width: 19px;
      height: 30px;
    }

    width: 140px;
    height: 30px;
    overflow: hidden;
    position: absolute;
    margin-left: -120px;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    //z-index:0;

    ::v-deep {
      .VInput {
        position: relative;
        pointer-events: all;
        z-index: $dropdown-z-index;

        input {
          margin-top: -15px;
          transition: all .2s $transition-function;
          border: 1px solid #6089e7;
          width: 110px;
          position: absolute;
          border-radius: 4px;
          transform: translateX(0px);
          padding-left: 10px;

        }

      }

      .VInput_hidden {
        input {

        }
      }

      .VInput_showed {
        input {
          transform: translateX(-140px);

        }

      }

    }

  }
</style>
